import { styled } from 'styled-system/jsx'

const Shell = styled('div', {
  base: {
    minHeight: '100vh',
    backgroundColor: 'app.bg',
    color: 'app.fg',
    display: 'flex',
    flexDirection: 'column',
  },
})

const Main = styled('main', {
  base: {
    flex: 1,
    width: '100%',
  },
})

export { Shell, Main }
